import { useEffect } from 'react';
import { sendAdobeAnalyticsTransaction } from 'ciam-self-service-shared';
import { TRANSACTION_ERROR } from 'utils/constants';

const sendToAdobe = (type, transaction, error, stepNumber) => {
  sendAdobeAnalyticsTransaction(type, {
    transaction: {
      transactionName: transaction?.name,
      transactionType: transaction?.type,
      transactionCategory: transaction?.category,
      transactionStep: stepNumber,
      ...(error && {
        errorCode: error.errorCode,
        errorType: error.errorType,
        errorDescription: error.description,
      }),
    },
  });
};

const useAdobeAnalyticsTransaction = (type, transaction, error, step) => {
  useEffect(() => {
    sendToAdobe(type, transaction, null, step);
  }, [transaction, step, type]);

  useEffect(() => {
    if (error?.errorCode) {
      sendToAdobe(TRANSACTION_ERROR, transaction, error, step);
    }
  }, [error, transaction, step]);
};

export default useAdobeAnalyticsTransaction;
